import gql from 'graphql-tag';

export const GET_UNALLOCATED_TOKEN_AMOUNT = gql`
  query getUnallocatedTokenAmount {
    getUnallocatedTokenAmount
  }
`;
